module.exports = __webpack_public_path__ + "static/media/icons-camera.8572810a.svg";